import s from './styles.module.css';
import React, { useEffect, useMemo, useState } from 'react';
import { useTable } from 'react-table';
import ArrayIsEmpty from '../../UI/Array-is-empty/Array-is-empty';
import CustomModal from '../../UI/Modal/Modal';
import Pagination from '../../UI/Pagination/Pagination';
import { useNavigate } from 'react-router-dom';
import { axiosInstances } from '../../../api/axios-instances';
import { Select } from 'antd';
import StatusColor from '../../UI/statusColor/statusColor';
import { useMutation, useQueryClient } from 'react-query';
import { Option } from 'antd/es/mentions';
import { useBuyers } from '../../../api/user-list-api/user-list-api';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

const UserOrdersTurkeyTable = ({
    t,
    language,
    initialData,
    openModalTurkeyUse,
    page,
    setPage,
    refetch,
    handleCloseModalTurkey,
    setOpenModalTurkeyUse,
}) => {
    const [tableData, setTableData] = useState([]);
    const queryClient = useQueryClient();
    const { data: buyersData } = useBuyers();
    const [orderCreateTurkey, setOrderCreateTurkey] = useState({
        name: '',
        track_code: '',
        price: 0,
        weight: 0,
        amount: '',
        customer_id: 0,
        city_id: 0,
        filial_id: 0,
        order_source: '',
        buyer_id: 0,
        shipping_method: 'Avia',
    });
    const [successModal, setSuccessModal] = useState(false);
    const [selectedBuyer, setSelectedBuyer] = useState(null);
    const [errors, setErrors] = useState({});
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [role, setRole] = useState(null);
    const navigate = useNavigate();
    const [expandedRow, setExpandedRow] = useState(null);
    useEffect(() => {
        if (initialData && initialData.content) {
            setTableData(initialData.content);
        }
    }, [initialData]);
    const totalPages = initialData && initialData.totalPages;
    const token = Cookies.get('token');
    useEffect(() => {
        if (token && typeof token === 'string') {
            try {
                const decodedToken = jwtDecode(token);
                setRole(decodedToken.id);
            } catch (error) {
                console.error('Ошибка декодирования токена', error);
                setRole('');
            }
        } else {
            setRole('');
        }
    }, [token]);

    const createOrderByUserTurkey = useMutation({
        mutationFn: async (user) => {
            const response = await axiosInstances.post(
                `/amantrans/order_turkey/customer/create`,
                user,
                {
                    headers: {
                        Authorization: `Bearer ${Cookies.get('token')}`,
                        'Content-Type': 'application/json',
                    },
                },
            );
            if (response.status !== 200) {
                throw new Error(`Error: ${response.status}`);
            }
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['customers']);
        },
        onError: (error) => {
            console.error('Error updating customer:', error);
        },
    });
    const handleChangeBuyer_d = (value) => {
        setOrderCreateTurkey((prevState) => ({
            ...prevState,
            buyer_id: value,
        }));
    };
    const handleChangeOrderSource = (value) => {
        setSelectedBuyer(value);
        setOrderCreateTurkey((prevState) => ({
            ...prevState,
            order_source: value,
        }));
    };
    const typeBuyer = ['От Байера', 'От оптовика', 'Само-зарегистрированный'];
    const validateInputs = () => {
        const newErrors = {};
        if (!orderCreateTurkey.name) newErrors.name = 'Имя пустое';
        // if (!orderCreateTurkey.track_code) newErrors.track_code = 'Трек код пустой';
        // if (!orderCreateTurkey.price || isNaN(orderCreateTurkey.price))
        //     newErrors.price = 'Цена должна быть';
        // if (!orderCreateTurkey.amount || isNaN(orderCreateTurkey.amount))
        //     newErrors.amount = 'Количество должно быть цифрой';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSaveOrderTurkey = () => {
        if (validateInputs()) {
            const updateData = {
                name: orderCreateTurkey.name,
                track_code: orderCreateTurkey.track_code,
                price: 1,
                weight: orderCreateTurkey.weight,
                amount: 1,
                order_source: orderCreateTurkey.order_source,
                buyer_id: selectedBuyer === 'От Байера' ? orderCreateTurkey.buyer_id : null,
                customer_id: role,
                shipping_method: orderCreateTurkey.shipping_method,
            };
            createOrderByUserTurkey.mutate(updateData, {
                onSuccess: () => {
                    setOpenModalTurkeyUse(false);
                    setOrderCreateTurkey({
                        name: '',
                        track_code: '',
                        price: 0,
                        amount: '',
                        customer_id: 0,
                        city_id: 0,
                        filial_id: 0,
                        order_source: '',
                        buyer_id: 0,
                        shipping_method: 'Avia',
                    });
                    setSuccessModal(true);
                    refetch();
                },
                onError: (error) => {
                    console.error('Error updating customer:', error);
                },
            });
        } else {
            setShowErrorMessage(true);
            setTimeout(() => {
                setErrors({});
                setShowErrorMessage(false);
            }, 2000);
        }
    };

    const handleCreateCloseModal = () => {
        setSuccessModal(false);
    };
    const columns = useMemo(
        () => [
            {
                Header: t('nameOrder'),
                accessor: 'name',
            },
            {
                Header: t('trackCode'),
                accessor: 'track_code',
                Cell: ({ value }) => value || 'N/A',
            },
            {
                Header: t('ID code'),
                accessor: 'customer.id_code',
                Cell: ({ value }) => value || 'N/A',
            },
            {
                Header: 'Байер',
                accessor: 'buyer_name',
            },
            {
                Header: t('type-lenovo-delivery'),
                accessor: 'shipping_method',
            },
            {
                Header: t('price'),
                accessor: 'price',
                Cell: ({ value }) => (value ? `${value}$` : 'N/A'),
            },
            {
                Header: t('amount'),
                accessor: 'amount',
            },
            {
                Header: t('taridId'),
                accessor: 'tariff_price',
                Cell: ({ value }) => (value ? `${value}$` : 'N/A'),
            },
            {
                Header: t('weight'),
                accessor: 'weight',
            },
            {
                Header: t('created_at'),
                accessor: 'created_at',
                Cell: ({ value }) => {
                    const date = new Date(value);
                    return date.toLocaleDateString();
                },
            },
            {
                Header: t('boxPrice'),
                accessor: 'box_tariff',
                Cell: ({ row }) => {
                    const avto =
                        row.original.shipping_method === 'Avto'
                            ? row.original.box_tariff
                            : row.original.box_price;
                    return avto;
                },
            },
            {
                Header: t('delivery'),
                accessor: 'delivery_price',
            },
            {
                Header: t('allPrices'),
                accessor: 'total_price',
                Cell: ({ row }) => {
                    const avto =
                        row.original.shipping_method === 'Avto'
                            ? row.original.box_tariff
                            : row.original.box_price;
                    // if (new Date(row.original.created_at) >= new Date('2024-12-10')) {
                    const boxPrice = parseFloat(avto) || 0;
                    const deliveryPrice = parseFloat(row.original.delivery_price) || 0;
                    const usd = parseFloat(row.original.usd) || 0;
                    const additionalWeight = parseFloat(row.original.additional_weight) || 0;

                    const totalPrice = (
                        (boxPrice + deliveryPrice + additionalWeight) *
                        usd
                    ).toFixed(1);

                    return `(${boxPrice} + ${deliveryPrice} + ${additionalWeight}) * ${usd} = ${totalPrice} тенге`;
                    // } else {
                    //     const usd = parseFloat(row.original.usd) || 0;
                    //     const boxTariff = parseFloat(row.original.box_tariff) || 0;
                    //     const boxWeight = parseFloat(row.original.weight) || 0;
                    //     const tariffPrice = parseFloat(row.original.tariff_price) || 0;
                    //     const additionalWeight = parseFloat(row.original.additional_weight) || 0;
                    //
                    //     const totalPrice = (
                    //         (boxWeight * tariffPrice + boxTariff + additionalWeight) *
                    //         usd
                    //     ).toFixed(1);
                    //
                    //     return `((${boxWeight} * ${tariffPrice}) + ${boxTariff} +  ${additionalWeight}) * ${usd} = ${totalPrice} тг`;
                    // }
                },
            },
            {
                Header: t('statusLan'),
                accessor: 'status',
                Cell: ({ value, row }) => (
                    <p className={s['status-color-name']} style={StatusColor(value.name_ru)}>
                        {language === 'ru' ? value.name_ru : value.name_kz}
                    </p>
                ),
            },
            {
                Header: t('plus-information'),
                accessor: 'plus-information',
                Cell: ({ row }) => (
                    <div className={s['button-div']}>
                        <p
                            className={s['button-table']}
                            onClick={() =>
                                navigate(`/info-turkey`, { state: { rowData: row.original } })
                            }
                        >
                            {t('fullInfoButton')}
                        </p>
                    </div>
                ),
            },
        ],
        [language],
    );
    const tableInstance = useTable({
        columns,
        data: tableData,
    });
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;
    return (
        <div className={s['table-container']}>
            <CustomModal visible={openModalTurkeyUse} onClose={handleCloseModalTurkey}>
                <div className={s['form']}>
                    <p className={s['modal-title']}>{t('createOrderByClient')}</p>
                    <div className={s['input-container']}>
                        <input
                            value={orderCreateTurkey.name}
                            style={{ padding: '5px, 10px' }}
                            className={`${s['input-modal']} ${errors.name ? s['input-error'] : ''}`}
                            onChange={(e) =>
                                setOrderCreateTurkey((prevState) => ({
                                    ...prevState,
                                    name: e.target.value,
                                }))
                            }
                        />
                        <label className={s['floating-label']}>{t('productName')}</label>
                    </div>
                    <div className={s['input-container']}>
                        <input
                            value={orderCreateTurkey.weight}
                            style={{ padding: '5px, 10px' }}
                            className={`${s['input-modal']} ${errors.weight ? s['input-error'] : ''}`}
                            onChange={(e) =>
                                setOrderCreateTurkey((prevState) => ({
                                    ...prevState,
                                    weight: e.target.value,
                                }))
                            }
                        />
                        <label className={s['floating-label']}>{t('weight')}</label>
                    </div>
                    {/*<div className={s['input-container']}>*/}
                    {/*    <input*/}
                    {/*        value={orderCreateTurkey.price}*/}
                    {/*        type="number"*/}
                    {/*        style={{ padding: '5px, 10px' }}*/}
                    {/*        className={`${s['input-modal']} ${errors.price ? s['input-error'] : ''}`}*/}
                    {/*        onChange={(e) =>*/}
                    {/*            setOrderCreateTurkey((prevState) => ({*/}
                    {/*                ...prevState,*/}
                    {/*                price: e.target.value,*/}
                    {/*            }))*/}
                    {/*        }*/}
                    {/*    />*/}
                    {/*    <label className={s['floating-label']}>{t('price')}</label>*/}
                    {/*</div>*/}
                    {/*<div className={s['input-container']}>*/}
                    {/*    <input*/}
                    {/*        value={orderCreateTurkey.amount}*/}
                    {/*        type="number"*/}
                    {/*        style={{ padding: '5px, 10px' }}*/}
                    {/*        className={`${s['input-modal']} ${errors.amount ? s['input-error'] : ''}`}*/}
                    {/*        onChange={(e) =>*/}
                    {/*            setOrderCreateTurkey((prevState) => ({*/}
                    {/*                ...prevState,*/}
                    {/*                amount: e.target.value,*/}
                    {/*            }))*/}
                    {/*        }*/}
                    {/*    />*/}
                    {/*    <label className={s['floating-label']}>{t('quantity')}</label>*/}
                    {/*</div>*/}
                    <div className={s['input-container']}>
                        <select
                            className={`${s['input-modal']}`}
                            name="shipping_method"
                            value={orderCreateTurkey.shipping_method}
                            onChange={(e) =>
                                setOrderCreateTurkey((prevState) => ({
                                    ...prevState,
                                    shipping_method: e.target.value,
                                }))
                            }
                        >
                            <option value="Avto">Avto</option>
                            <option value="Avia">Avia</option>
                        </select>
                        <label style={{ top: '10px' }} className={`${s['floating-label']}`}>
                            {t('type-delivery')}
                        </label>{' '}
                    </div>
                    <div className={s['input-container']}>
                        <Select
                            className={s['input-modal-select']}
                            onChange={handleChangeOrderSource}
                            placeholder={t('selectSeller')}
                        >
                            {typeBuyer?.map((item) => (
                                <Option value={item} key={item}>
                                    {item}
                                </Option>
                            ))}
                        </Select>
                    </div>
                    {selectedBuyer === 'От Байера' && (
                        <div className={s['input-container']}>
                            <Select
                                className={s['input-modal-select']}
                                onChange={handleChangeBuyer_d}
                                placeholder={t('selectBuyer')}
                            >
                                {buyersData?.map((item) => (
                                    <Option value={item.id} key={item.id}>
                                        {item.name}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    )}
                    {showErrorMessage && (
                        <p className={s['error-message']}>Заполните, пожалуйста, все поля.</p>
                    )}
                    <div className={s['modal-button']}>
                        <button className={s['button-modal']} onClick={handleCloseModalTurkey}>
                            {t('cancel')}
                        </button>
                        <button className={s['button-modal']} onClick={handleSaveOrderTurkey}>
                            {t('save')}
                        </button>
                    </div>
                </div>
            </CustomModal>

            <CustomModal visible={successModal} onClose={handleCreateCloseModal}>
                <div className={s['done-modal']}>
                    <p className={s['userPlus']}>Заказ создан успешно</p>
                    <svg
                        width="101"
                        height="101"
                        viewBox="0 0 101 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M50.1357 100.842C43.3057 100.842 36.8678 99.5346 30.822 96.9202C24.8089 94.3058 19.4985 90.6947 14.8906 86.0869C10.2828 81.479 6.67169 76.1686 4.05731 70.1555C1.44293 64.1098 0.135742 57.6719 0.135742 50.8418C0.135742 44.0117 1.44293 37.5902 4.05731 31.5771C6.67169 25.5313 10.2665 20.2045 14.8416 15.5967C19.4495 10.9889 24.7599 7.37774 30.773 4.76337C36.8187 2.14899 43.2567 0.841797 50.0867 0.841797C56.9168 0.841797 63.3547 2.14899 69.4005 4.76337C75.4462 7.37774 80.773 10.9889 85.3808 15.5967C89.9887 20.2045 93.5998 25.5313 96.2142 31.5771C98.8286 37.5902 100.136 44.0117 100.136 50.8418C100.136 57.6719 98.8286 64.1098 96.2142 70.1555C93.5998 76.1686 89.9887 81.479 85.3808 86.0869C80.773 90.6947 75.4462 94.3058 69.4005 96.9202C63.3874 99.5346 56.9658 100.842 50.1357 100.842ZM44.6455 74.7634C45.4952 74.7634 46.2632 74.5673 46.9495 74.1751C47.6357 73.783 48.2403 73.1947 48.7632 72.4104L71.8024 36.0869C72.0965 35.5967 72.3743 35.0738 72.6357 34.5183C72.8972 33.9627 73.0279 33.4072 73.0279 32.8516C73.0279 31.7078 72.6031 30.8091 71.7534 30.1555C70.9037 29.4692 69.956 29.1261 68.9103 29.1261C67.4723 29.1261 66.2959 29.8777 65.3808 31.381L44.4495 65.0085L34.4985 52.1653C33.8776 51.3483 33.273 50.7928 32.6848 50.4987C32.1292 50.2045 31.492 50.0575 30.773 50.0575C29.6619 50.0575 28.7305 50.466 27.9789 51.283C27.2272 52.0673 26.8514 53.015 26.8514 54.1261C26.8514 54.6817 26.9495 55.2372 27.1455 55.7928C27.3743 56.3157 27.6684 56.8222 28.0279 57.3124L40.3318 72.4104C40.9854 73.2601 41.6553 73.8647 42.3416 74.2242C43.0279 74.5836 43.7959 74.7634 44.6455 74.7634Z"
                            fill="white"
                        />
                    </svg>
                    <button className={s['button-done']} onClick={handleCreateCloseModal}>
                        Продолжить
                    </button>
                </div>
            </CustomModal>
            <div className={s['table-order']}>
                {tableData.length === 0 ? (
                    <ArrayIsEmpty textOfEmpty={t('emptyPageOrder')} />
                ) : (
                    <>
                        <table className={s['table']} {...getTableProps()}>
                            <thead>
                                {headerGroups.map((headerGroup) => {
                                    const { key: headerGroupKey, ...headerGroupRest } =
                                        headerGroup.getHeaderGroupProps();
                                    return (
                                        <tr key={headerGroupKey} {...headerGroupRest}>
                                            {headerGroup.headers.map((column) => {
                                                const { key: columnKey, ...columnRest } =
                                                    column.getHeaderProps();
                                                return (
                                                    <th
                                                        key={columnKey}
                                                        className={s['th-style']}
                                                        {...columnRest}
                                                    >
                                                        {column.render('Header')}
                                                    </th>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                                {rows.map((row) => {
                                    prepareRow(row);
                                    const { key: rowKey, ...rowRest } = row.getRowProps();
                                    return (
                                        <tr className={s['tbody']} key={rowKey} {...rowRest}>
                                            {row.cells.map((cell) => {
                                                const { key: cellKey, ...cellRest } =
                                                    cell.getCellProps();
                                                return (
                                                    <td
                                                        key={cellKey}
                                                        className={s['td-style']}
                                                        {...cellRest}
                                                    >
                                                        {cell.render('Cell')}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <div className={s['mobile-view']}>
                            {rows.map((row) => {
                                prepareRow(row);
                                const isExpanded = expandedRow === row.id;
                                return (
                                    <div key={row.id} className={s['mobile-row']}>
                                        <div className={s['mobile-header']}>
                                            <div className={s['mobile-summary']}>
                                                <p>
                                                    <span className={s['row-text-1']}>
                                                        {t('nameOrder')}:
                                                    </span>{' '}
                                                    {row.original.name}
                                                </p>
                                                <p>
                                                    <span className={s['row-text-1']}>
                                                        {t('trackCode')}:
                                                    </span>{' '}
                                                    {row.original.track_code}
                                                </p>
                                                <p>
                                                    <span className={s['row-text-1']}>
                                                        {t('price')}:
                                                    </span>{' '}
                                                    {row.original.price}$
                                                </p>
                                            </div>
                                            {isExpanded && (
                                                <div className={s['mobile-content']}>
                                                    {row.cells.map((cell, cellIndex) => {
                                                        if (
                                                            cell.column.id === 'name' ||
                                                            cell.column.id === 'track_code' ||
                                                            cell.column.id === 'price'
                                                        ) {
                                                            return null;
                                                        }
                                                        return (
                                                            <div
                                                                key={cell.column.id}
                                                                className={`${s['mobile-cell']} ${cellIndex === 3 ? s['with-line'] : ''}`}
                                                            >
                                                                <div className={s['mobile-header']}>
                                                                    <span
                                                                        className={s['row-text-1']}
                                                                    >
                                                                        {`${cell.column.Header}:`}
                                                                    </span>
                                                                </div>
                                                                <div
                                                                    className={s['mobile-content']}
                                                                >
                                                                    <span className={s['row-text']}>
                                                                        {cell.render('Cell')}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                            <button
                                                className={s['toggle-button']}
                                                onClick={() =>
                                                    setExpandedRow(isExpanded ? null : row.id)
                                                }
                                            >
                                                {isExpanded ? (
                                                    <>
                                                        Скрыть
                                                        <svg
                                                            width="26"
                                                            height="26"
                                                            viewBox="0 0 26 26"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M12.9985 12.2536L9.38296 15.8691L7.96875 14.4549L12.9985 9.42519L18.0282 14.4549L16.614 15.8691L12.9985 12.2536Z"
                                                                fill="#898D94"
                                                            />
                                                        </svg>
                                                    </>
                                                ) : (
                                                    <>
                                                        Показать еще
                                                        <svg
                                                            width="26"
                                                            height="26"
                                                            viewBox="0 0 26 26"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M13.0015 13.7464L16.617 10.1309L18.0312 11.5451L13.0015 16.5748L7.97178 11.5451L9.38599 10.1309L13.0015 13.7464Z"
                                                                fill="#898D94"
                                                            />
                                                        </svg>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                )}
            </div>
            <div className={s['div-pages']}>
                {totalPages > 1 && (
                    <Pagination totalPages={totalPages} currentPage={page} setPage={setPage} />
                )}
            </div>
        </div>
    );
};
export default UserOrdersTurkeyTable;
